import React, { useEffect, useState } from 'react';
import Icon, { IconType } from '../Icon/Icon';

interface IProps {
  name?: string;
  placeholder?: string;
  id?: string;
  value?: string;
  onChange?: (value?: string) => void;
  onBlur?: () => void;
  className?: string;
  disabled?: boolean;
}

const ColorPicker = (props: IProps) => {
  const [value, setValue] = useState<string>();
  const [blurred, setBlurred] = useState<boolean>(false);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  useEffect(() => {
    if (blurred) {
      setBlurred(false);
      if (props.onBlur) {
        props.onBlur();
      }
    }
  }, [blurred]);

  const updateColor = (color?: string) => {
    setValue(color);
    if (props.onChange) {
      props.onChange(color);
    }
  };

  return (
    <>
      <div
        className={`color-picker form-control ${props.className}`}
        //   style={{ backgroundColor: value ? value : 'transparent' }}
      >
        <input
          name={props.name}
          id={props.id}
          type="color"
          value={props.value ? props.value : '#ffffff'}
          onChange={(e) => {
            const color = e.target.value;
            updateColor(color);
          }}
          disabled={props.disabled}
          onBlur={() => {
            setBlurred(true);
          }}
          placeholder="No color selected"
        />
        <input
          type="text"
          maxLength={7}
          value={props.value ? props.value : ''}
          onChange={(e) => {
            let color = e.target.value;
            if (color !== '' && color[0] !== '#') {
              color = '#' + color; // Ensure it starts with '#'
            }

            if (color && !/^#([0-9A-Fa-f]{*})$/.test(color)) {
              //remove invalid characters
              color = color.replace(/[^#0-9A-Fa-f]/g, '');
            }

            updateColor(color);
          }}
          disabled={props.disabled}
          onBlur={() => {
            setBlurred(true);
          }}
          placeholder="#aabbcc"
        />
        {!props.disabled && value ? (
          <span
            title="Remove color"
            className="click"
            onClick={() => {
              updateColor(undefined);
              setBlurred(true);
            }}>
            <Icon type={IconType.remove} />
          </span>
        ) : (
          <span>&nbsp;&nbsp; {props.placeholder ?? 'Not Set'}</span>
        )}
      </div>
    </>
  );
};

export default ColorPicker;
